import { lazy, Suspense, type PropsWithChildren } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { useAuth } from './auth';
import { LoginPage } from './login';
import { LandingPage, SignupPage } from './public-pages';
import { InvitationPage } from './invitation';

const SaasApplication = lazy(() =>
  import('./saas-application').then((module) => ({ default: module.SaasApplication })),
);

function RouteLoading({ label }: { label: string }) {
  return (
    <div className="route-loading" role="status">
      <span className="route-loading-spinner" aria-hidden="true" />
      <span>{label}…</span>
    </div>
  );
}

function Protected({ children }: PropsWithChildren) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <RouteLoading label="Restoring your session" />;
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}

export function App() {
  return (
    <Routes>
      <Route index element={<LandingPage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="signup" element={<SignupPage />} />
      <Route path="invitation" element={<InvitationPage />} />
      <Route
        path="*"
        element={
          <Protected>
            <Suspense fallback={<RouteLoading label="Opening workspace" />}>
              <SaasApplication />
            </Suspense>
          </Protected>
        }
      />
    </Routes>
  );
}
